window.addEventListener('DOMContentLoaded', () => {
  animationsRunner('.banner-title');
});

function animationsRunner(classList) {
  const textWrapper = document.querySelector(classList);

  const arr = textWrapper.querySelectorAll('h2');

  for (const element of arr) element.innerHTML = element.textContent.replace(/\S/g, "<span class='letter'>$&</span>");

  anime.timeline({ loop: false }).add({
    targets: '.banner-title .letter',
    opacity: [0, 1],
    easing: 'easeInOutQuad',
    duration: 300,
    delay: (el, i) => 30 * (i + 1),
  });
  setTimeout(() => {
    textWrapper.style.opacity = '1';
  }, 30);
}

function initHeroBanner() {
  const heroBannerList = document.querySelector('.hero-banner__list');
  const heroBannerNavItems = document.querySelectorAll('.hero-banner__nav-item');
  const heroButton = document.querySelector('.hero-banner__button');
  const circleButton = heroButton.querySelector('.circle');
  const textElement = document.querySelector('.hero-banner__button .text p');
  const text = textElement.innerText + ' ';
  const radius = 8;
  const angle = 360 / text.length;

  // Banner slider
  if (heroBannerList) {
    heroBannerList.classList.remove('carousel');

    const flickityHeroBanner = new Flickity(heroBannerList, {
      cellAlign: 'left',
      imagesLoaded: true,
      contain: true,
      pageDots: false,
      wrapAround: true,
      autoPlay: 5000,
      prevNextButtons: false,
    });

    heroBannerNavItems.forEach((navItem, index) => {
      navItem.addEventListener('click', () => {
        flickityHeroBanner.select(index);
      });
    });

    flickityHeroBanner.on('change', (index) => {
      animationsRunner(`[data-id="herro-banner-title-${index + 1}"]`);

      document.querySelector('.hero-banner__nav-item.active').classList.remove('active');

      heroBannerNavItems[index].classList.add('active');
    });
  }

  // Circle text
  heroButton.classList.add('loaded');
  circleButton.classList.remove('hidden');

  textElement.innerHTML = text
    .split('')
    .map(
      (char, i) =>
        `<span style="position: absolute; transform: rotate(${i * angle}deg) translateY(-${radius}px)">${char}</span>`
    )
    .join('');
}

document.addEventListener('DOMContentLoaded', initHeroBanner);
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', initHeroBanner);
  document.addEventListener('shopify:section:reorder', initHeroBanner);
}
